import moment from 'moment';
moment.locale('zh-cn');

export const formatTime = function(date, type = "YYYY-MM-DD HH:mm") {
  return moment(date).format(type);
};

export const dateFormat = (value, format = 'YYYY-MM-DD') => {
  return moment(value).format(format);
}

export const dateFormat2 = (value, format = 'MM月DD日') => {
  return value ? moment(value * 1000).format(format) : ''
}
export const dayFormat = (value) => {
  let day = new Date(parseInt(value) * 1000).getDay()
  switch (day) {
    case 0: day = '周日'
      break
    case 1: day = '周一'
      break
    case 2: day = '周二'
      break
    case 3: day = '周三'
      break
    case 4: day = '周四'
      break
    case 5: day = '周五'
      break
    case 6: day = '周六'
      break
  }
  return day
}

export const dateAndDayFormat = (value) => {
  let day = new Date(parseInt(value) * 1000).getDay()
  var mydate = new Date();
  var myddy = mydate.getDay()
  if (myddy == day) {
    day = '今天'
    return day + dateFormat2(value)
  } else if (myddy == day - 1) {
    day = '明天'
    return day + dateFormat2(value)
  } else if (myddy == day - 2) {
    day = '后天'
    return day + dateFormat2(value)
  }
  switch (day) {
    case 0: day = '周日'
      break
    case 1: day = '周一'
      break
    case 2: day = '周二'
      break
    case 3: day = '周三'
      break
    case 4: day = '周四'
      break
    case 5: day = '周五'
      break
    case 6: day = '周六'
      break
  }
  return day + dateFormat2(value)
}

export const phoneFormat = (value) => {
  return !isNaN(value) ? value.substring(0, 3) + '****' + value.substring(7, 11) : ''
}

/* 格式化文件大小 */
export const filesize = function(bytes) {
  var unit = "B";
  if (bytes > 1024) {
    bytes /= 1024;
    unit = "KB";
  }
  if (bytes > 1024) {
    bytes /= 1024;
    unit = " MB";
  }
  return Number(bytes.toFixed(1)) + " " + unit;
};
/* 计算已过去的时间 */
export const timepast = function(timestamp) {
  var uminute = 60;
  var uhour = uminute * 60;
  var uday = uhour * 24;
  var umonth = uday * 30;
  var uyear = umonth * 12;
  var diff = (new Date().getTime() - timestamp) / 1000;
  if (diff < 60) return Math.abs(Math.ceil(diff)) + "秒前";
  var year = parseInt(diff / uyear);
  if (year > 0) return year + "年前";
  var month = parseInt(diff / umonth);
  if (month > 0) return month + "个月前";
  var week = parseInt(diff / (uday * 7));
  if (week > 0) return week + "周前";
  var days = parseInt(diff / uday);
  if (days > 0) return days + "天前";
  var hours = parseInt(diff / uhour);
  if (hours > 0) return hours + "小时前";
  var minites = parseInt(diff / uminute);
  if (minites > 0) return minites + "分钟前";
};

export default {
  install(Vue) {
    Vue.filter('dateFormat', dateFormat)
    Vue.filter('dateFormat2', dateFormat2)
    Vue.filter('dayFormat', dayFormat)
    Vue.filter('dateAndDayFormat', dateAndDayFormat)
    Vue.filter('phoneFormat', phoneFormat)
    Vue.filter('filesize', filesize)
    Vue.filter('timepast', timepast)
    Vue.filter('formatTime',formatTime)
  }
}
